import { render } from "./PickingUp.vue?vue&type=template&id=4dbea6f9&scoped=true"
import script from "./PickingUp.vue?vue&type=script&lang=js"
export * from "./PickingUp.vue?vue&type=script&lang=js"

import "./PickingUp.vue?vue&type=style&index=0&id=4dbea6f9&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbea6f9"]])

export default __exports__